import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import './Breadcrumbs.css';

const Breadcrumbs = ({ segments }) => {
  const getBreadCrumbSegment = (segment, index) => {
    if (!segment.linkTo) {
      return segment.label;
    }

    if (index === segment.length - 1) {
      return segment.label;
    }

    if (segment.label === '') {
      return <Link to={segment.linkTo}>Unknown</Link>;
    }

    return <Link to={segment.linkTo}>{segment.label}</Link>;
  };

  return (
    <ol className="breadcrumbs" aria-label="breadcrumbs">
      {segments.map((segment, index) => (
        <li className="breadcrumbs-segment" key={segment.label}>
          {getBreadCrumbSegment(segment, index)}
        </li>
      ))}
    </ol>
  );
};

Breadcrumbs.propTypes = {
  segments: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    linkTo: PropTypes.string,
  }),).isRequired,
};

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./src/components/common/Breadcrumbs.jsx